<template>
  <div class="print-order px-2 mx-0 pagebreak">
    <table class="table print-customer-table  mt-2">
      <tbody> 
        <!-- <tr v-if="settings != ''" class="print-order-shop ">
          <td class="print-order-item-title ">
            <span class="text-center">
              فروشگاه
            </span>
          </td>
          <td
            class="print-order-item-info text-right"
            style="padding-right:5px!important"
          >
            <div
              class="print-order-item-address pb-lg-1 pt-1 align-items-center"
            >
              <div style="flex-shrink: 0">
                <span class="font-weight-bold fontsize15 mb-0">
                  عنوان :
                </span>
                <span class="mb-0 pr-1 fontsize14 pl-2">
                  {{
                    settings.filter((item) => item.name == "shop_name")[0].value
                  }}
                </span>
                <div style="display: inline">
                  <span class="font-weight-bold fontsize15 mb-0">
                    کدپستی :
                  </span>
                  <span class="mb-0 fontsize14 pr-1 pl-2">
                    {{
                      settings.filter(
                        (item) => item.name == "shop_postal_code"
                      )[0].value
                    }}
                  </span>
                </div>
              </div>
              <div>
                <span class="font-weight-bold fontsize15 mb-0">
                  آدرس :
                </span>
                <span class="mb-0 pr-1 fontsize14 pl-2">
                  {{
                    settings.filter((item) => item.name == "shop_address")[0]
                      .value
                  }}
                </span>
              </div>
              <div>
                <span class="mb-0 pr-1 fontsize14 pl-2">
                  {{
                    settings.filter((item) => item.name == "shop_telephone")[0]
                      .value
                  }}
                </span>
              </div>
            </div>
          </td>
          <td class="print-order-item-call">
            <div class=" d-flex flex-column text-center px-1">
              <span
                style="margin-bottom: -7px!important;padding-bottom: 0!important;"
                v-if="$options.configProvider.get('print_logo', null)"
              >
                <img
                  style="margin-bottom: 0!important;padding-bottom: 0!important;"
                  class="logo"
                  :src="$options.configProvider.get('print_logo', null)"
                />
              </span>
              <span
                style="height: 16px;margin-top: 0!important;padding-top: 0!important;"
              >
                {{
                  settings.filter((item) => item.name == "shop_url")[0].value
                }}
              </span>
            </div>
          </td>
        </tr> -->



        
        <tr class="print-order-shop ">
          <td class="print-order-item-title ">
            <span class="text-center">
              خریدار
            </span>
          </td>
          <td
            class="print-order-item-info px-1 text-right"
            style="line-height:20px!important;"
          >
            <div class=" pt-0">
              <span class="font-weight-bold fontsize15 mb-0">
                نام کامل :
                <span
                  class="mb-0 pr-1 fontsize14 pl-2"
                  style="font-weight: 500"
                >
                  {{ address.first_name }} {{ address.last_name }}
                </span>
              </span>
            </div>
            <div class="d-flex print-order-item-address align-items-center">
              <div>
                <span class="font-weight-bold fontsize14 mb-0 ">
                  گیرنده :
                </span>
                <span
                  v-if="order.shipping && order.shipping.id == 2"
                  class="mb-0 pr-1 fontsize13 pl-1"
                >
                  تحویل درب فروشگاه
                </span>
                <span v-else class="mb-0 pr-1 fontsize13 pl-1">
                  {{ address.city.province ? address.city.province.name : "" }}
                  - {{ address.city ? address.city.name : "" }} -
                  {{ address.address }}
                </span>
              </div>
            </div>
            <div class="">
              <span class="font-weight-bold fontsize13 mb-0">
                کدپستی:
              </span>
              <span class="mb-0 fontsize14 pl-2">
                {{ address.postal_code }}
              </span>
              <span class="font-weight-bold fontsize13 mb-0">
                تلفن:
              </span>
              <span class="mb-0 fontsize14 pl-2">
                {{ address.mobile }}
              </span>
              <span v-if="invoice" class="print-order-invoice">
                <span class="font-weight-bold fontsize15 mb-0">
                  روش پرداخت:
                </span>
                <span
                  v-if="invoice.type == 'gateway'"
                  class="mb-0 fontsize14 pl-2"
                >
                  درگاه {{ invoicePayment ? invoicePayment.gateway_label : "" }}
                </span>
                <span
                  v-else-if="invoice.type == 'wallet'"
                  class="mb-0 fontsize14 pl-2"
                >
                  کیف پول
                </span>
              </span>
              <span class="print-order-invoice">
                <span class="font-weight-bold fontsize15 mb-0">
                  شیوه بسته بندی:
                </span>
                <span v-if="order.gift_package_id" class="mb-0 fontsize14 pl-2">
                  {{ order.gift_package.name }}
                </span>
                <span v-else class="mb-0 fontsize14 pl-2">
                  عادی (پیش فرض)
                </span>
              </span>
            </div>
          </td>
          <td class="print-order-item-call">
            <div class="text-center  px-1">
              <span class="font-weight-bold" style="font-size: 21px">
                {{ order.id }}
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <template v-if="!$route.query.label">
      <div style="text-align: right" v-if="order.description" class="card">
        <div class="card-header">
          توضیحات
        </div>
        <div class="card-body">
          {{ order.description }}
        </div>
      </div>
      <b-table
        responsive
        :items="order.active_items"
        :fields="fields"
        bordered
        :tbody-tr-class="rowClass"
        class="table print-customer-order-table  mt-2"
      >
        <template v-slot:cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <template v-slot:cell(product)="data">
          <p style="line-height:2" class="pTitle mb-0">
            {{ data.item.product.title }}
            <span
              v-if="data.item.extra.color || data.item.extra.attributes != ''"
              class="mr-1"
            >
            </span>
            <span v-if="data.item.extra.color != null">
              رنگ : {{ data.item.extra.color }}
              {{
                data.item.extra.color && data.item.extra.attributes != ""
                  ? " | "
                  : ""
              }}
            </span>
            <span v-if="data.item.extra.attributes != ''">
              <span
                v-for="(attr, index) in data.item.extra.attributes"
                :key="index"
              >
                {{ attr.label + ":" + attr.pivot.value }}
                {{
                  index != data.item.extra.attributes.length - 1 ? " | " : ""
                }}
              </span>
            </span>
          </p>
        </template>
        <template v-slot:cell(amount)="data">
          <span v-if="data.item.amount != 0"
            >{{ (data.item.amount + data.item.discount_amount) | price }} تومان
          </span>
          <span v-else>0</span>
        </template>
        <template v-slot:cell(quantity)="data">
          <span style="font-weight: bold">{{ data.item.quantity }}</span>
        </template>
        <template v-slot:cell(discount_amount)="data">
          <span v-if="data.item.discount_amount"
            >{{ data.item.discount_amount | price }} تومان</span
          >
          <span v-else>ندارد</span>
        </template>
        <template v-slot:cell(total_price)="data">
          <span v-if="data.item.amount != 0"
            >{{ (data.item.amount * data.item.quantity) | price }} تومان
          </span>
          <span v-else>0</span>
        </template>
        <template v-slot:cell(note)="data">
          <span v-if="data.item.isReserved == false">
            {{ new Date(data.item.created_at).toLocaleDateString("fa") }}
          </span>
        </template>
      </b-table>
      <div class="d-flex justify-content-end">
        <table
          class="table print-order-total-table text-right"
          style="width:400px"
        >
          <tbody>
            <tr class="print-order-shop ">
              <td class="py-2">
                <span class="font-weight-bold px-2">مبلغ کل</span>
              </td>
              <td class="">
                <span v-if="totalDiscountFromItems">{{
                  (total + totalDiscountFromItems) | price
                }}</span>
                <span
                  v-else-if="order.discount_amount && !totalDiscountFromItems"
                  >{{ total | price }}</span
                >
                <span v-else>{{ total | price }}</span>
                تومان
              </td>
            </tr>
            <tr class="print-order-shop ">
              <td class="py-2">
                <span class="font-weight-bold px-2">هزینه حمل و نقل</span>
              </td>
              <td class="">
                <span v-if="order.shipping_amount != 0">
                  {{ order.shipping_amount | price }} تومان
                </span>
                <span v-else-if="order.shipping.is_free" class="">
                  درب منزل
                </span>
                <span v-else class="">
                  رایگان
                </span>
              </td>
            </tr>
            <tr class="print-order-shop ">
              <td class="py-2">
                <span class="font-weight-bold px-2">هزینه بسته بندی </span>
              </td>
              <td class="">
                <span v-if="order.gift_package_price != 0">
                  {{ order.gift_package_price | price }} تومان
                </span>
                <span v-else class="">
                  رایگان
                </span>
              </td>
            </tr>
            <tr v-if="totalDiscountFromItems" class="print-order-shop ">
              <td class="py-2">
                <span class="font-weight-bold px-2">مبلغ تخفیف</span>
              </td>
              <td class="">
                <span v-if="totalDiscountFromItems">
                  {{ totalDiscountFromItems | price }} تومان
                </span>
                <span v-else class="">
                  0
                </span>
              </td>
            </tr>
            <tr
              v-if="order.discount_amount && !totalDiscountFromItems"
              class="print-order-shop "
            >
              <td class="py-2">
                <span class="font-weight-bold px-2">مبلغ تخفیف کوپن</span>
              </td>
              <td class="">
                <span v-if="order.discount_amount != 0">
                  {{ order.discount_amount | price }} تومان
                </span>
                <span v-else class="">
                  0
                </span>
              </td>
            </tr>
            <tr class="print-order-shop ">
              <td class="py-2">
                <span class="font-weight-bold px-2">مبلغ پرداختی</span>
              </td>
              <td class="">{{ totalPrice | price }} تومان</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <div class="text-center print-order-btn mb-4">
      <button class="btn btn-print text-white" @click="orderPrint()">
        چاپ فاکتور
      </button>
      <!-- <button class="btn btn-print text-white mr-1">بازگشت</button> -->
    </div>
  </div>
</template>
<script>
import OrderPrintItemImpl from "@@/core/components/order/OrderPrintItem/OrderPrintItemImpl";
export default {
  extends: OrderPrintItemImpl,
};
</script>

<style
  scoped
  src="@@/core/components/order/OrderPrintItem/OrderPrintItemStyle.css"
></style>
